// UnverifiedEmailSection.jsx
// Modern component for handling unverified email state with professional design

import React from 'react';
import { styles } from './styles';
import { WarningIcon } from '../../components/Icons';

const UnverifiedEmailSection = ({ 
  unverifiedUser, 
  onResendVerification, 
  cooldown 
}) => {
  if (!unverifiedUser) return null;

  const buttonStyle = {
    ...styles.resendButton,
    ...(cooldown ? styles.resendButtonDisabled : styles.resendButtonEnabled)
  };

  return (
    <div style={styles.unverifiedSection}>
      <div style={styles.unverifiedHeader}>
        <WarningIcon 
          size={20} 
          color="#F9D016" 
          style={styles.unverifiedIcon}
        />
        <h4 style={styles.unverifiedTitle}>Email Verification Required</h4>
      </div>
      
      <p style={styles.unverifiedText}>
        Please check your email inbox and click the verification link to activate your account. 
        <strong>Check your Junk/Spam folder - verification emails often end up there!</strong>
        The verification email may take a few minutes to arrive.
      </p>
      
      <button 
        onClick={onResendVerification} 
        disabled={cooldown}
        style={buttonStyle}
        onMouseEnter={(e) => {
          if (!cooldown) {
            e.target.style.backgroundColor = '#F9D016';
            e.target.style.color = '#000000';
            e.target.style.transform = 'translateY(-1px)';
          }
        }}
        onMouseLeave={(e) => {
          if (!cooldown) {
            e.target.style.backgroundColor = 'transparent';
            e.target.style.color = '#F9D016';
            e.target.style.transform = 'translateY(0)';
          }
        }}
      >
        {cooldown ? 'Please wait...' : 'Resend Verification Email'}
      </button>
    </div>
  );
};

export default UnverifiedEmailSection;